export const AcquireStatus = {
    "PRELIMINARY_INVESTIGATION": "前期调研",
    "ONLY_SSU": "仅SSU",
    "ONLY_AFTER_STARTUP": "仅启动后",
    "PRE_START_ASSISTANCE_AFTER_STARTUP": "启动前协助+启动后",
    "SSU_LEAD_AFTER_STARTUP": "SSU主导+启动后",
};

// 需求类型
export const RequirementType = {
    "SSU_LEAD": "SSU主导",
    "PRE_START_ASSISTANCE": "启动前协助",
    "AFTER_STARTUP_MEMBER": "启动后人员",
};

// 需求来源
export const RequirementOrigin = {
    "CREATE": "新建",
    "HANDOVER": "交接",
    "SUPPLEMENT": "补充",
};

// 启动前需求类型
export const StartBeforeType = {
    "SSU_LEAD": "SSU主导",
    "PRE_START_ASSISTANCE": "启动前协助"
};

// 需求类型 -> 项目类型
export const RequirementTypeInInvType = {
    'SSU_LEAD': 'before',
    'PRE_START_ASSISTANCE': 'before',
    'AFTER_STARTUP_MEMBER': 'after',
};

// 项目类型
export const RequirementInfo = {
    "before": "启动前",
    "after": "启动后",
};

export const Status = {
    "NEW": "新建",
    "ASSIGNED": "预分配",
    "REASSIGNED": "重新分配",
    "REJECTED": "被拒绝",
    "ACTIVE": "已确认",
};

export const MedicineType = {
    "Research_drugs": "药物",
    "Technology": "技术类（如细胞技术）",
    "Medical_instruments": "医疗器械",
    "Vaccines": "疫苗",
    "Diagnostic_reagent": "诊断试剂",
    "Others": "其他",
};

export const Default = {
    '0': '否',
    '1': '是',
};

export const Storage = {
    invId: '',
    curRole: '',
    isTotal: true,
    isConcrete: false
};

export function genStorage() {
    const { invId, curRole, invState } = sessionStorage;
    Storage.invId = invId;
    Storage.curRole = curRole;
    Storage.isTotal = invState == 0;
    Storage.isConcrete = invState == 2;
}

export function includes(arr, val) {
    return arr.indexOf(val) !== -1;
}



// WEBPACK FOOTER //
// ./src/components/user/require/constants.js